/*
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2023-10-27 12:13:13
 */
/**
 * 获取地址栏参数
 * 使用: let urlSearch = new getUrlSearch
 */
export const getUrlSearch = () => {
  // 获取查询参数部分
  const searchParams = new URLSearchParams(location.search)

  // 创建一个对象来存储参数
  const paramsObject = {}

  // 遍历所有查询参数
  for (const [name, value] of searchParams) {
    paramsObject[name] = value
  }

  return paramsObject
}

/**
 * @description: 判断是否json数据
 * @param {*} data
 * @return {*}
 */
export function isJson(data) {
  try {
    // 尝试解析数据为JSON
    const parsedData = JSON.parse(data)

    // 如果成功解析为JSON，则返回解析后的数据
    return parsedData
  } catch (error) {
    // 解析失败，返回原始数据
    return data
  }
}

/**
 * @description: ?时间格式转化
 * @param {*} inputTime 时间
 * @param {*} format 格式
 * @return {*}
 */
export function formatDateTime(inputTime, format) {
  let date

  // 判断时间参数的类型
  if (typeof inputTime === 'number') {
    date = new Date(inputTime)
  } else if (typeof inputTime === 'string') {
    date = new Date(inputTime)
  } else if (inputTime instanceof Date) {
    date = inputTime
  } else {
    // 无法解析输入时间参数
    return 'Invalid Date'
  }

  if (isNaN(date)) {
    // 如果无法解析输入时间参数，则返回 "Invalid Date"
    return 'Invalid Date'
  }

  // 创建一个对象，用于存储时间部分的格式化结果
  const formattedParts = {
    y: date.getFullYear(),
    m: String(date.getMonth() + 1).padStart(2, '0'),
    d: String(date.getDate()).padStart(2, '0'),
    h: String(date.getHours()).padStart(2, '0'),
    m: String(date.getMinutes()).padStart(2, '0'),
    s: String(date.getSeconds()).padStart(2, '0')
  }

  // 遍历格式参数中的字符，将其映射为相应时间部分的格式化结果
  let formattedTime = ''
  for (let i = 0; i < format.length; i++) {
    const char = format[i]
    if (formattedParts[char]) {
      formattedTime += formattedParts[char]
    } else {
      formattedTime += char
    }
  }

  return formattedTime
}
// 示例用法
const inputTime = new Date() // 可以传入日期对象、时间戳或日期字符串
const format = 'y-m-d h:m:s'

const formattedTime = formatDateTime(inputTime, format)
console.log(formattedTime) // 输出指定格式的日期时间字符串

// 数字每千位加逗号
/**
 *
 * @param {Number} num
 * @returns
 */
export function toThousands(num) {
  return (
    num &&
    num.toString().replace(/\d+/, function (s) {
      return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    })
  )
}

/**
 * @description: 获取当前时间
 * @return {*}
 */
export function getCurrentDateTime() {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

/**
 * @description: 获取最近n天的日期
 * @param {*} n
 * @return {*}
 */
export function getRecentNDays(n) {
  const result = []
  const today = new Date() // 当前日期
  for (let i = 0; i < n; i++) {
    const date = new Date(today) // 复制当前日期
    date.setDate(today.getDate() - i) // 减去 i 天
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从 0 开始，需要加 1
    const day = String(date.getDate()).padStart(2, '0')
    const formattedDate = `${year}-${month}-${day}`
    result.push(formattedDate)
  }
  return result
}

/**
 * 平滑滚动到页面顶部
 */
export const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop)
    window.scrollTo(0, c - c / 8)
  }
}

/**
 *
 * @returns 获取滚动条距顶部高度
 */
export function getPageScrollTop() {
  let a = document
  return a.documentElement.scrollTop || a.body.scrollTop
}

/**
 *
 * 浏览器链接下载文件
 * @param {url} link
 * @param {*} name 文件名称
 */
export function download(link, name) {
  if (!name) {
    name = link.slice(link.lastIndexOf('/') + 1)
  }
  let eleLink = document.createElement('a')
  eleLink.download = name
  eleLink.style.display = 'none'
  eleLink.href = link
  document.body.appendChild(eleLink)
  eleLink.click()
  document.body.removeChild(eleLink)
}

/**
 * 保留小数点以后几位，默认2位
 * @param {number} number
 * @param {*} no 保留几位数
 * @returns
 */
export function cutNumber(number, no = 2) {
  if (typeof number != 'number') {
    number = Number(number)
  }
  return Number(number.toFixed(no))
}

/**
 * 获取文件后缀名
 * @param {String} filename
 */
export function getExt(filename) {
  if (typeof filename == 'string') {
    return filename.split('.').pop().toLowerCase()
  } else {
    throw new Error('filename must be a string type')
  }
}
